<nw-container [title]="config.title" [width]="300">
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="outer-container">
    <div
      *ngIf="elements$ | async as elements"
      fxLayout="column"
      fxLayoutAlign="start"
      fxLayoutGap="12px"
      class="element-container"
    >
      <div *ngIf="!elements.length">There are no items in the list</div>
      <div
        *ngFor="let element of elements$ | async"
        class="element"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        (mouseenter)="mouseenter(element)"
        (mouseleave)="mouseleave()"
      >
        <div (click)="select(element)" fxFlex>
          {{ element.literals.label }}
        </div>
        <nw-loader *ngIf="element === deletedElement" [size]="17"></nw-loader>
        <nw-icon
          *ngIf="element === selectedElement"
          type="close"
          [size]="17"
          (click)="delete(element)"
          matTooltip="Delete"
        ></nw-icon>
      </div>
    </div>
    <nw-center *ngIf="loading">
      <nw-loader> </nw-loader>
    </nw-center>
    <div class="footer" fxLayout="row" fxLayoutAlign=" center">
      <nw-text-input
        *ngIf="addMode"
        [text]="newEntityName"
        [create]="create.bind(this)"
        [cancel]="cancel.bind(this)"
      ></nw-text-input>
      <div *ngIf="!addMode" (click)="add()" fxLayout="row" fxLayoutAlign=" center">
        <nw-icon matTooltip="New" type="add" [size]="22"></nw-icon>
      </div>
    </div>
  </div>
</nw-container>
